import React from 'react';
import { HeartIcon } from 'lucide-react';
import { TroveGenrePage } from '../../components/Trove/TroveGenrePage';
import type { TroveArticle, TroveEvent, TroveNominee } from '../../components/Trove/TroveGenrePage';
import type { ActivityPost } from '../../components/Trove/ActivityPostCard';
const activityPosts: ActivityPost[] = [{
  id: 1,
  type: 'New Release',
  title: 'A Court of Silver Flames',
  description: 'Sarah J. Maas returns with the fourth installment in the ACOTAR series.',
  author: 'Sarah J. Maas',
  date: 'Oct 15, 2023',
  genre: 'Romance',
  image: 'https://images.unsplash.com/photo-1474552226712-ac0f0961a954?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
}, {
  id: 2,
  type: 'Cover Reveal',
  title: 'The Midnight Library — Special Edition',
  description: 'A stunning new cover for the beloved bestseller, revealed exclusively here.',
  author: 'Matt Haig',
  date: 'Oct 14, 2023',
  genre: 'Romance'
}, {
  id: 3,
  type: 'Collaboration Request',
  title: 'Looking for Romance Beta Readers',
  description: 'Debut author seeking sensitivity readers for contemporary romance with LGBTQ+ themes.',
  author: 'Jordan Ellis',
  date: 'Oct 13, 2023',
  genre: 'Romance'
}, {
  id: 4,
  type: 'Event Announcement',
  title: 'Romance Writers of America Annual Conference',
  description: 'Join thousands of romance writers and readers for the premier industry event.',
  author: 'RWA',
  date: 'Oct 12, 2023',
  genre: 'Romance'
}, {
  id: 5,
  type: 'Award Nomination',
  title: 'Best Indie Romance 2023 — Nominations Open',
  description: "Submit your favourite indie romance novels for consideration in this year's awards.",
  author: 'Indie Lit Awards',
  date: 'Oct 11, 2023',
  genre: 'Romance'
}, {
  id: 6,
  type: 'Vendor Availability',
  title: 'Romance Cover Designer — Open for Commissions',
  description: 'Specialising in contemporary and paranormal romance covers. 3 slots available for Q1 2024.',
  author: 'Luna Design Co.',
  date: 'Oct 10, 2023',
  genre: 'Romance'
}];
const articles: TroveArticle[] = [{
  id: 1,
  title: 'The Evolution of Romance Tropes in 2023',
  excerpt: 'How classic romance tropes are being reimagined for modern readers...',
  author: 'Emma Clarke',
  date: 'October 9, 2023',
  category: 'Romance',
  readTime: '7 min read',
  image: 'https://images.unsplash.com/photo-1474552226712-ac0f0961a954?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  id: 2,
  title: 'Diversity in Romance: Beyond the Mainstream',
  excerpt: 'Exploring the growing diversity in romance fiction and its impact...',
  author: 'Priya Sharma',
  date: 'October 6, 2023',
  category: 'Romance',
  readTime: '9 min read',
  image: 'https://images.unsplash.com/photo-1516575334481-f85287c2c82d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}];
const interviews: TroveArticle[] = [{
  id: 101,
  title: 'Breaking Boundaries in Romance: A Conversation with Jasmine Guillory',
  excerpt: 'The bestselling author discusses representation, modern love stories, and her writing process...',
  author: 'Literary Voices',
  date: 'October 12, 2023',
  category: 'Romance',
  readTime: '12 min read',
  image: 'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  type: 'interview'
}, {
  id: 102,
  title: 'Emily Henry on Beach Reads, Character Development and Finding Joy in Fiction',
  excerpt: 'An in-depth discussion with the author who has redefined contemporary romance...',
  author: 'Book Lovers Club',
  date: 'October 8, 2023',
  category: 'Romance',
  readTime: '15 min read',
  image: 'https://images.unsplash.com/photo-1506880018603-83d5b814b5a6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  type: 'interview'
}];
const podcasts: TroveArticle[] = [{
  id: 201,
  title: 'Fated Mates',
  excerpt: 'A podcast about romance novels and the genius women who write them, hosted by Sarah MacLean and Jen Prokop...',
  author: 'Sarah MacLean & Jen Prokop',
  date: 'Weekly',
  category: 'Romance',
  readTime: '45-60 min episodes',
  image: 'https://images.unsplash.com/photo-1478737270239-2f02b77fc618?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  type: 'podcast'
}, {
  id: 202,
  title: 'Smart Podcast, Trashy Books',
  excerpt: 'Interviews with romance authors, industry insights, and discussions about the genre...',
  author: 'Sarah Wendell',
  date: 'Weekly',
  category: 'Romance',
  readTime: '40-50 min episodes',
  image: 'https://images.unsplash.com/photo-1581368087049-7034ed0d1e6f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  type: 'podcast'
}];
const upcomingEvents: TroveEvent[] = [{
  name: 'Romance Writers Convention',
  date: 'Nov 15, 2023',
  location: 'New York, NY'
}, {
  name: 'Indie Romance Summit',
  date: 'Dec 2, 2023',
  location: 'Virtual'
}];
const awardNominees: TroveNominee[] = [{
  id: 1,
  name: 'The Love Hypothesis',
  author: 'Ali Hazelwood',
  votes: 2341
}, {
  id: 2,
  name: 'Beach Read',
  author: 'Emily Henry',
  votes: 2187
}];
const RomanceTrove = () => <TroveGenrePage title="Romance" subtitle="Discover the latest trends, discussions, and insights in romance fiction" icon={<HeartIcon className="h-6 w-6" data-id="element-17296" data-mp="26hsivqatjv5f" />} searchPlaceholder="Search romance content..." activityPosts={activityPosts} articles={articles} interviews={interviews} podcasts={podcasts} upcomingEvents={upcomingEvents} awardNominees={awardNominees} articlesHref="/trove/romance/articles" data-id="element-17295" data-mp="2gddumg5ow9sd" />;
export default RomanceTrove;